// @ts-nocheck
import LogoText from "../assets/images/logo-text.png";
import BgImage from "../assets/images/frontpage-bg.png";
import { getTourPath } from "../utils";

interface Props {
  tours: Tour[];
  customers: Customer[];
}
function FrontPage(props: Props) {
  const { tours, customers } = props;

  const favoriteTour = tours.find((tour) => tour.showOnFrontpage);
  const favoritePath = favoriteTour ? getTourPath(favoriteTour, customers) : null;

  return (
    <div className="frontpage-container">
      <div className="left-container">
        <img className="logo-text" src={LogoText} alt="" />
        <img className="bg-image" src={BgImage} alt="" />
        <h1 id="frontpage">Løft din ejendoms-præsentation til det næste niveau!</h1>
        <p>
          Vi hjælper med at styrke din position i den hastigt udviklende digitale verden, samt forbedrer kundeoplevelsen med
          virtual tours.
        </p>
        {/*         <div className="contact-email-container">
          <div className="left-contact-email-container">
            <img src={Email} alt="Email logo" />
          </div>
          <div className="right-contact-email-container">
            <p>Kontakt os i dag!</p>
            <a href="mailto:kontakt@vr-estate.dk">kontakt@vr-estate.dk</a>
          </div>
        </div> */}
      </div>
      <div className="right-container">
        <div style={{ height: "100%", width: "95%" }}>
          <iframe
            id="frontpage-vr-demo"
            title="VR Estate"
            width="100%"
            height="100%"
            src={favoritePath ? `/${favoritePath}` : undefined}
            frameborder="0"
            allowfullscreen
            allow="xr-spatial-tracking autoplay"
          ></iframe>
        </div>
      </div>
    </div>
  );
}

export default FrontPage;
